module.exports = __webpack_public_path__ + "img/b.fbf0b27e.webp";